import React from 'react';
import { Row } from 'react-bootstrap';
import { connect } from 'react-redux';

import { getPermissions, getUser } from '../../Login/selectors';
import { getCodeGroups } from '../selectors';
import CodeGroupListContainer from './CodeGroupList/CodeGroupListContainer';
import CouponListContainer from './CouponList/CouponListContainer';

class CouponsPage extends React.Component {
  state = {
    codeGroupList: null,
  };

  render() {
    const { user = {}, permissions = [] } = this.props;
    const canEdit = user.isSuperAdmin
      ? true
      : permissions.find((r) => r === 'Settings.EditCoupons');
    return (
      <Row style={{ height: '100%' }}>
        <CouponListContainer
          setCodeGroupList={(codeGroupList) => this.setState({ codeGroupList })}
          canEdit={canEdit}
        />
        <CodeGroupListContainer
          onSelectAnalytics={(analyticsCodeGroup) =>
            this.setState({ analyticsCodeGroup })
          }
          setCodeGroupList={(codeGroupList) => this.setState({ codeGroupList })}
          canEdit={canEdit}
        />
      </Row>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  codeGroups: getCodeGroups(state),
  user: getUser(state),
  permissions: getPermissions(state),
});

export default connect(mapStateToProps, null)(CouponsPage);
